import React from "react";

export const Hamburger = () => (
	<svg
		width={30}
		height={16}
		viewBox="0 0 30 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30 0.75C30 1.16421 29.6642 1.5 29.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75C0 0.335786 0.335786 0 0.749999 0H29.25C29.6642 0 30 0.335786 30 0.75Z"
			fill="url(#paint0_linear_739_7303)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30 7.75C30 8.16421 29.6642 8.5 29.25 8.5H0.75C0.335786 8.5 0 8.16421 0 7.75C0 7.33579 0.335786 7 0.749999 7H29.25C29.6642 7 30 7.33579 30 7.75Z"
			fill="url(#paint1_linear_739_7303)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30 14.75C30 15.1642 29.6642 15.5 29.25 15.5H0.75C0.335786 15.5 0 15.1642 0 14.75C0 14.3358 0.335786 14 0.749999 14H29.25C29.6642 14 30 14.3358 30 14.75Z"
			fill="url(#paint2_linear_739_7303)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_739_7303"
				x1="1.16997e-07"
				y1="0.749997"
				x2={30}
				y2="0.749999"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#24e9c4" />
				<stop offset={1} stopColor="#24E9C4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_739_7303"
				x1="1.16997e-07"
				y1="7.75"
				x2={30}
				y2="7.75"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#24e9c4" />
				<stop offset={1} stopColor="#24E9C4" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_739_7303"
				x1="1.16997e-07"
				y1="14.75"
				x2={30}
				y2="14.75"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#24e9c4" />
				<stop offset={1} stopColor="#24E9C4" />
			</linearGradient>
		</defs>
	</svg>
);
export const ClearIcon = () => (
	<svg
		width={23}
		height={24}
		viewBox="0 0 23 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.0175 1.31713C22.3104 1.61002 22.3104 2.08489 22.0175 2.37779L1.86492 22.5303C1.57202 22.8232 1.09715 22.8232 0.804256 22.5303C0.511363 22.2374 0.511362 21.7626 0.804255 21.4697L20.9568 1.31713C21.2497 1.02423 21.7246 1.02423 22.0175 1.31713Z"
			fill="url(#paint0_linear_744_7321)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.530393 1.31713C0.237499 1.61002 0.237498 2.08489 0.530393 2.37779L20.6829 22.5303C20.9758 22.8232 21.4507 22.8232 21.7436 22.5303C22.0365 22.2374 22.0365 21.7626 21.7436 21.4697L1.59105 1.31713C1.29816 1.02423 0.823286 1.02423 0.530393 1.31713Z"
			fill="url(#paint1_linear_744_7321)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_744_7321"
				x1="0.804254"
				y1="22.5303"
				x2="22.0175"
				y2="1.31713"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#24E9C4" />
				<stop offset={1} stopColor="#24E9C4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_744_7321"
				x1="21.7436"
				y1="22.5303"
				x2="0.530393"
				y2="1.31713"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#24E9C4" />
				<stop offset={1} stopColor="#24E9C4" />
			</linearGradient>
		</defs>
	</svg>
);
export const Facebook = () => (
	<svg
		width="36"
		height="36"
		viewBox="0 0 36 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="35.9895" height="35.9895" rx="7.86125" fill="#342C9C" />
		<path
			d="M22.398 19.1663L22.9107 15.9083H19.752V13.7906C19.752 12.8997 20.193 12.0292 21.6032 12.0292H23.0595V9.25479C22.2114 9.11955 21.3544 9.04639 20.4956 9.03589C17.8958 9.03589 16.1985 10.5987 16.1985 13.424V15.9083H13.3167V19.1663H16.1985V27.0466H19.752V19.1663H22.398Z"
			fill="white"
		/>
	</svg>
);
export const Instagram = () => (
	<svg
		width="37"
		height="36"
		viewBox="0 0 37 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.989746"
			width="35.9895"
			height="35.9895"
			rx="7.86125"
			fill="#342C9C"
		/>
		<path
			d="M15.9899 18.0409C15.9899 16.3831 17.333 15.0389 18.9903 15.0389C20.6476 15.0389 21.9915 16.3831 21.9915 18.0409C21.9915 19.6987 20.6476 21.0429 18.9903 21.0429C17.333 21.0429 15.9899 19.6987 15.9899 18.0409ZM14.3675 18.0409C14.3675 20.5948 16.4371 22.665 18.9903 22.665C21.5435 22.665 23.6131 20.5948 23.6131 18.0409C23.6131 15.487 21.5435 13.4167 18.9903 13.4167C16.4371 13.4167 14.3675 15.487 14.3675 18.0409ZM22.7158 13.2334C22.7157 13.4471 22.779 13.6561 22.8976 13.8338C23.0163 14.0116 23.185 14.1502 23.3823 14.232C23.5797 14.3139 23.7969 14.3354 24.0065 14.2938C24.2161 14.2522 24.4086 14.1493 24.5598 13.9983C24.7109 13.8472 24.8139 13.6547 24.8556 13.4451C24.8974 13.2355 24.8761 13.0182 24.7944 12.8207C24.7127 12.6232 24.5743 12.4544 24.3967 12.3355C24.2191 12.2167 24.0103 12.1533 23.7966 12.1532H23.7962C23.5097 12.1533 23.2351 12.2672 23.0325 12.4697C22.83 12.6722 22.7161 12.9469 22.7158 13.2334ZM15.3532 25.3711C14.4755 25.3311 13.9984 25.1848 13.6814 25.0613C13.261 24.8976 12.9611 24.7026 12.6458 24.3877C12.3305 24.0727 12.1353 23.773 11.9724 23.3526C11.8488 23.0356 11.7026 22.5582 11.6627 21.6802C11.6191 20.731 11.6104 20.4458 11.6104 18.041C11.6104 15.6361 11.6198 15.3517 11.6627 14.4017C11.7027 13.5237 11.85 13.0473 11.9724 12.7294C12.136 12.3089 12.3309 12.009 12.6458 11.6935C12.9607 11.3781 13.2603 11.1829 13.6814 11.0199C13.9982 10.8963 14.4755 10.7501 15.3532 10.7102C16.3022 10.6665 16.5872 10.6578 18.9903 10.6578C21.3934 10.6578 21.6788 10.6672 22.6285 10.7102C23.5063 10.7501 23.9825 10.8975 24.3004 11.0199C24.7207 11.1829 25.0206 11.3786 25.3359 11.6935C25.6512 12.0085 25.8457 12.3089 26.0093 12.7294C26.1329 13.0464 26.2791 13.5237 26.319 14.4017C26.3627 15.3517 26.3714 15.6361 26.3714 18.041C26.3714 20.4458 26.3627 20.7302 26.319 21.6802C26.279 22.5582 26.1321 23.0354 26.0093 23.3526C25.8457 23.773 25.6508 24.073 25.3359 24.3877C25.021 24.7024 24.7207 24.8976 24.3004 25.0613C23.9835 25.1849 23.5063 25.3311 22.6285 25.3711C21.6796 25.4147 21.3945 25.4234 18.9903 25.4234C16.5862 25.4234 16.3019 25.4147 15.3532 25.3711ZM15.2787 9.09006C14.3203 9.13372 13.6654 9.28573 13.0934 9.50834C12.5011 9.73823 11.9997 10.0466 11.4986 10.5471C10.9976 11.0475 10.6901 11.5498 10.4602 12.1423C10.2377 12.7148 10.0857 13.3695 10.0421 14.3282C9.9977 15.2884 9.98755 15.5953 9.98755 18.0409C9.98755 20.4865 9.9977 20.7934 10.0421 21.7536C10.0857 22.7124 10.2377 23.367 10.4602 23.9395C10.6901 24.5316 10.9977 25.0345 11.4986 25.5347C11.9996 26.0349 12.5011 26.3429 13.0934 26.5735C13.6664 26.7961 14.3203 26.9481 15.2787 26.9917C16.2391 27.0354 16.5455 27.0463 18.9903 27.0463C21.4352 27.0463 21.7421 27.0361 22.702 26.9917C23.6605 26.9481 24.3149 26.7961 24.8872 26.5735C25.4792 26.3429 25.9809 26.0351 26.482 25.5347C26.9831 25.0343 27.2899 24.5316 27.5204 23.9395C27.743 23.367 27.8957 22.7123 27.9386 21.7536C27.9822 20.7927 27.9924 20.4865 27.9924 18.0409C27.9924 15.5953 27.9822 15.2884 27.9386 14.3282C27.8949 13.3694 27.743 12.7144 27.5204 12.1423C27.2899 11.5502 26.9823 11.0483 26.482 10.5471C25.9817 10.0459 25.4792 9.73823 24.8879 9.50834C24.3149 9.28573 23.6604 9.133 22.7027 9.09006C21.7428 9.0464 21.4359 9.03552 18.991 9.03552C16.5462 9.03552 16.2391 9.04568 15.2787 9.09006Z"
			fill="white"
		/>
	</svg>
);
export const Twitter = () => (
	<svg
		width="37"
		height="36"
		viewBox="0 0 37 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.979492"
			width="35.9895"
			height="35.9895"
			rx="7.86125"
			fill="#342C9C"
		/>
		<path
			d="M27.9065 12.2971C27.3122 12.553 26.6875 12.7313 26.0477 12.8274C26.3468 12.7761 26.7869 12.2372 26.9621 12.0191C27.2283 11.6901 27.4311 11.3145 27.5603 10.9114C27.5603 10.8815 27.5903 10.8387 27.5603 10.8173C27.5453 10.8091 27.5284 10.8048 27.5112 10.8048C27.494 10.8048 27.4771 10.8091 27.4621 10.8173C26.7674 11.1938 26.028 11.4812 25.2615 11.6727C25.2348 11.6808 25.2063 11.6816 25.1792 11.6748C25.1521 11.668 25.1274 11.654 25.1077 11.6342C25.048 11.5631 24.9838 11.4959 24.9154 11.4332C24.6027 11.1528 24.248 10.9233 23.8642 10.7532C23.3461 10.5404 22.7865 10.4483 22.2277 10.4837C21.6854 10.518 21.156 10.6636 20.6723 10.9114C20.196 11.1727 19.7775 11.5276 19.4417 11.9549C19.0885 12.3947 18.8336 12.9051 18.6939 13.4518C18.5788 13.9718 18.5657 14.5092 18.6555 15.0342C18.6555 15.124 18.6555 15.1368 18.5786 15.124C15.532 14.6749 13.0323 13.5929 10.9898 11.2706C10.9001 11.168 10.8531 11.168 10.7804 11.2706C9.89165 12.6221 10.3232 14.7605 11.4342 15.8168C11.5837 15.958 11.7376 16.0948 11.8999 16.2231C11.3906 16.1869 10.8936 16.0488 10.4386 15.8168C10.3531 15.7612 10.3061 15.7912 10.3019 15.8938C10.2897 16.0361 10.2897 16.1792 10.3019 16.3215C10.391 17.0035 10.6595 17.6495 11.08 18.1935C11.5004 18.7376 12.0576 19.1601 12.6947 19.4179C12.85 19.4844 13.0118 19.5346 13.1776 19.5676C12.706 19.6605 12.2224 19.6749 11.7461 19.6103C11.6436 19.5889 11.6051 19.6445 11.6436 19.7429C12.2717 21.4536 13.6348 21.9754 14.6346 22.2662C14.7714 22.2876 14.9081 22.2876 15.0619 22.3218C15.0619 22.3218 15.0619 22.3218 15.0363 22.3474C14.7415 22.8863 13.5493 23.2498 13.0024 23.438C12.0041 23.7969 10.9397 23.9341 9.8831 23.84C9.71646 23.8144 9.678 23.8187 9.63527 23.84C9.59254 23.8614 9.63527 23.9085 9.68227 23.9512C9.89592 24.0924 10.1096 24.2164 10.3318 24.3361C10.9932 24.6973 11.6925 24.9841 12.417 25.1915C16.1686 26.2265 20.3903 25.4652 23.2062 22.6639C25.4196 20.4657 26.1973 17.4335 26.1973 14.397C26.1973 14.2815 26.3383 14.2131 26.4195 14.1532C26.9794 13.7165 27.4731 13.2007 27.8851 12.6221C27.9564 12.5358 27.993 12.426 27.9876 12.3142C27.9876 12.25 27.9876 12.2628 27.9065 12.2971Z"
			fill="white"
		/>
	</svg>
);
export const LinkedinIn = () => (
	<svg
		width="37"
		height="36"
		viewBox="0 0 37 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.969238"
			width="35.9895"
			height="35.9895"
			rx="7.86125"
			fill="#342C9C"
		/>
		<path
			d="M14.8238 24.4481V14.7263H11.5953V24.4481H14.8242H14.8238ZM13.2103 13.3991C14.3359 13.3991 15.0366 12.6526 15.0366 11.7197C15.0156 10.7655 14.3359 10.0398 13.2317 10.0398C12.1267 10.0398 11.405 10.7655 11.405 11.7196C11.405 12.6525 12.1055 13.3991 13.1891 13.3991H13.21L13.2103 13.3991ZM16.6109 24.4481H19.8391V19.0195C19.8391 18.7294 19.8602 18.4384 19.9455 18.2312C20.1788 17.6504 20.71 17.0492 21.602 17.0492C22.77 17.0492 23.2374 17.9407 23.2374 19.2477V24.4481H26.4656V18.8739C26.4656 15.8879 24.8731 14.4983 22.7491 14.4983C21.0076 14.4983 20.2428 15.4725 19.8179 16.136H19.8394V14.7266H16.611C16.6532 15.6386 16.6108 24.4484 16.6108 24.4484L16.6109 24.4481Z"
			fill="white"
		/>
	</svg>
);
export const ArrowDown = () => (
	<svg
		width={16}
		height={61}
		viewBox="0 0 16 61"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.2929 60.7071C7.68342 61.0976 8.31659 61.0976 8.70711 60.7071L15.0711 54.3432C15.4616 53.9526 15.4616 53.3195 15.0711 52.9289C14.6805 52.5384 14.0474 52.5384 13.6569 52.9289L8 58.5858L2.34315 52.9289C1.95262 52.5384 1.31946 52.5384 0.928935 52.9289C0.53841 53.3195 0.53841 53.9526 0.928935 54.3432L7.2929 60.7071ZM7 4.37114e-08L7 60L9 60L9 -4.37114e-08L7 4.37114e-08Z"
			fill="white"
		/>
	</svg>
);
export const ProtoTypingIcon = () => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width={60} height={60} rx={15} fill="white" />
		<path
			d="M38.4497 30.5H42.5481C43.9024 30.5 45.0002 31.5979 45.0002 32.9522V43.5478C45.0002 44.9021 43.9024 46 42.5481 46H38.4497C37.0954 46 35.9976 44.9021 35.9976 43.5478V32.9522C35.9976 31.5979 37.0954 30.5 38.4497 30.5Z"
			stroke="#35333A"
			strokeWidth={2}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.4522 15H20.5505C21.9048 15 23.0027 16.0979 23.0027 17.4522V28.0478C23.0027 29.4021 21.9048 30.5 20.5505 30.5H16.4522C15.0979 30.5 14 29.4021 14 28.0478V17.4522C14 16.0979 15.0979 15 16.4522 15Z"
			stroke="#35333A"
			strokeWidth={2}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18.5015 35.6667V40.5007C18.5015 43.5379 20.9636 46 24.0008 46C27.038 46 29.5002 43.5379 29.5002 40.5007V20.4994C29.5002 17.4622 31.9623 15 34.9994 15C38.0366 15 40.4988 17.4622 40.4988 20.4994V25.3334"
			stroke="#35333A"
			strokeWidth={2}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const AiMachineIcon = () => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width={60} height={60} rx={15} fill="white" />
		<path
			d="M22.8756 34.5465C23.0317 34.6116 23.2073 34.6121 23.3637 34.5477C23.5201 34.4834 23.6446 34.3595 23.7097 34.2034L24.6089 32.0448H28.0105L28.9097 34.2034C29.0452 34.5285 29.4187 34.6821 29.7438 34.5465C30.0689 34.411 30.2225 34.0375 30.0869 33.7124L26.8983 26.0598C26.7993 25.8223 26.5671 25.6675 26.3097 25.6675C26.0524 25.6675 25.8202 25.8223 25.7212 26.0598L22.5326 33.7124C22.4674 33.8685 22.467 34.0441 22.5313 34.2005C22.5957 34.3569 22.7194 34.4814 22.8756 34.5465ZM26.3097 27.9633L27.4786 30.7693H25.1407L26.3097 27.9633Z"
			fill="black"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M31.4117 33.3201C31.0594 33.3201 30.7739 33.6056 30.7739 33.9578C30.7739 34.31 31.0594 34.5955 31.4117 34.5955H35.238C35.5902 34.5955 35.8757 34.31 35.8757 33.9578C35.8757 33.6056 35.5902 33.3201 35.238 33.3201H33.9625V26.9429H35.238C35.5902 26.9429 35.8757 26.6574 35.8757 26.3052C35.8757 25.953 35.5902 25.6675 35.238 25.6675H31.4117C31.0594 25.6675 30.7739 25.953 30.7739 26.3052C30.7739 26.6574 31.0594 26.9429 31.4117 26.9429H32.6871V33.3201H31.4117Z"
			fill="black"
		/>
		<path
			d="M11.0046 39.0595C11.0046 40.4684 12.1467 41.6104 13.5555 41.6104C13.875 41.6092 14.1914 41.5473 14.4878 41.428C15.9953 42.5823 18.1228 43.1843 20.7374 43.1843C21.1315 43.1843 21.541 43.1658 21.9561 43.139C23.808 46.9232 26.48 49.263 29.4983 49.263C32.5166 49.263 35.1887 46.9232 37.0412 43.1409C37.457 43.1677 37.8658 43.1862 38.2599 43.1862C40.8745 43.1862 43.002 42.5841 44.5095 41.4299C44.8059 41.5484 45.122 41.6097 45.4412 41.6104C46.5671 41.6072 47.5578 40.8662 47.8789 39.787C48.2 38.7079 47.7756 37.5458 46.8346 36.9276C46.9239 34.8742 46.1299 32.5439 44.514 30.1315C46.1299 27.7196 46.9239 25.3894 46.8346 23.3353C47.9371 22.6238 48.318 21.1908 47.7143 20.0258C47.1106 18.8608 45.7201 18.3457 44.5031 18.8362C42.7704 17.5104 40.2119 16.9231 37.0418 17.1297C35.1913 13.3424 32.518 11 29.4984 11C26.4788 11 23.8055 13.3424 21.9529 17.1297C18.7841 16.9244 16.2269 17.5123 14.4916 18.8363C13.2754 18.3497 11.8885 18.8656 11.2858 20.0286C10.6831 21.1917 11.0613 22.6223 12.1601 23.3354C12.0721 25.3882 12.8667 27.7184 14.4827 30.1315C12.8667 32.544 12.0721 34.8742 12.1621 36.9277C11.4408 37.3971 11.0054 38.199 11.0046 39.0595ZM12.2801 39.0595C12.2801 38.3552 12.8511 37.7841 13.5555 37.7841C14.26 37.7841 14.831 38.3551 14.831 39.0595C14.831 39.764 14.26 40.335 13.5555 40.335C13.2172 40.335 12.8928 40.2006 12.6536 39.9614C12.4144 39.7222 12.2801 39.3978 12.2801 39.0595ZM22.7444 18.4741C24.4421 18.6773 26.1147 19.0528 27.7364 19.5946C26.595 20.104 25.4802 20.6714 24.3967 21.2947C23.3093 21.9223 22.2561 22.6071 21.2413 23.3462C21.5756 21.6754 22.0793 20.0429 22.7444 18.4741ZM37.7549 23.3462C36.7404 22.607 35.6873 21.9222 34.6001 21.2947C33.5181 20.6722 32.4054 20.1047 31.2661 19.5946C32.8862 19.053 34.557 18.6777 36.2531 18.4741C36.9178 20.0429 37.421 21.6754 37.7549 23.3462ZM36.2524 41.789C34.5547 41.5857 32.8821 41.2103 31.2604 40.6685C32.4019 40.1591 33.5166 39.5916 34.6001 38.9683C35.6875 38.3408 36.7407 37.656 37.7555 36.9168C37.4212 38.5877 36.9176 40.2201 36.2524 41.789ZM33.9624 22.3998C35.4006 23.2275 36.7754 24.1604 38.0757 25.1911C38.3102 26.8275 38.4274 28.4785 38.4264 30.1315C38.4276 31.7846 38.3106 33.4356 38.0763 35.0719C36.7758 36.1026 35.4007 37.0356 33.9624 37.8632C32.5288 38.6924 31.0368 39.4167 29.4984 40.0302C27.9599 39.4163 26.468 38.6917 25.0344 37.8619C23.5962 37.0343 22.2214 36.1013 20.9211 35.0706C20.4543 31.7935 20.4543 28.4669 20.9211 25.1898C22.2215 24.1596 23.5964 23.2271 25.0344 22.3998C26.4692 21.5699 27.9625 20.8453 29.5022 20.2315C31.0394 20.8456 32.5301 21.5702 33.9624 22.3998ZM39.5106 26.3964C40.7825 27.5224 41.9377 28.7738 42.9587 30.1315C41.9392 31.489 40.7854 32.7404 39.5151 33.8666C39.6403 32.6256 39.7027 31.3789 39.7019 30.1315C39.7023 28.8841 39.6395 27.6375 39.5138 26.3964H39.5106ZM19.4862 33.8666C18.214 32.7409 17.0587 31.4895 16.0381 30.1315C17.0577 28.774 18.2114 27.5227 19.4817 26.3964C19.2309 28.8802 19.2309 31.3829 19.4817 33.8666H19.4862ZM24.4005 38.9683C25.4824 39.5909 26.5952 40.1583 27.7345 40.6685C26.1144 41.21 24.4435 41.5854 22.7475 41.789C22.0826 40.2201 21.5792 38.5877 21.245 36.9168C22.2585 37.656 23.3105 38.3408 24.3966 38.9683H24.4005ZM29.4984 47.9876C27.1031 47.9876 24.9266 46.0879 23.3215 43.0064C25.435 42.7068 27.5074 42.1667 29.4984 41.3968C31.4902 42.1671 33.5635 42.7071 35.6779 43.0064C34.0696 46.0879 31.8937 47.9876 29.4984 47.9876ZM45.4414 40.335C44.737 40.335 44.1659 39.764 44.1659 39.0595C44.1659 38.3551 44.7369 37.7841 45.4414 37.7841C46.1458 37.7841 46.7168 38.3551 46.7168 39.0595C46.7168 39.764 46.1457 40.335 45.4414 40.335ZM45.5752 36.5221C45.53 36.5221 45.4872 36.5087 45.4413 36.5087C44.0325 36.5087 42.8904 37.6508 42.8904 39.0595C42.8928 39.6298 43.0881 40.1825 43.4446 40.6277C42.0557 41.544 40.0284 41.9796 37.6 41.8884C38.3906 39.9132 38.951 37.8533 39.2701 35.7498C40.9196 34.4216 42.4123 32.9098 43.7195 31.2437C44.7962 32.807 45.4368 34.629 45.5752 36.5221ZM46.7168 21.2035C46.7168 21.9078 46.1457 22.4789 45.4413 22.4789C44.7369 22.4789 44.1658 21.9079 44.1658 21.2035C44.1658 20.499 44.7369 19.928 45.4413 19.928C46.1457 19.928 46.7168 20.4991 46.7168 21.2035ZM43.4446 19.6353C43.0882 20.0805 42.8929 20.6332 42.8904 21.2035C42.8904 22.6123 44.0325 23.7543 45.4413 23.7543C45.4872 23.7543 45.5299 23.7435 45.5752 23.7409C45.437 25.6341 44.7964 27.4562 43.7195 29.0193C42.4121 27.3532 40.9191 25.8413 39.2695 24.5132C38.95 22.4096 38.3889 20.3497 37.5974 18.3746C40.0278 18.2828 42.0563 18.7164 43.4446 19.6353ZM29.4984 12.2755C31.8937 12.2755 34.0702 14.1752 35.6753 17.2567C33.5629 17.5565 31.4915 18.0965 29.5016 18.8663C27.5098 18.096 25.4366 17.556 23.3222 17.2567C24.9272 14.1752 27.1031 12.2755 29.4984 12.2755ZM13.5555 19.9281C14.2598 19.9281 14.8309 20.4991 14.8309 21.2035C14.8309 21.908 14.2599 22.479 13.5555 22.479C12.851 22.479 12.28 21.908 12.28 21.2035C12.28 20.4991 12.8511 19.9281 13.5555 19.9281ZM13.4216 23.7409C13.4668 23.7409 13.5096 23.7543 13.5555 23.7543C14.9643 23.7543 16.1064 22.6122 16.1064 21.2035C16.104 20.6332 15.9087 20.0805 15.5522 19.6353C16.9405 18.719 18.9678 18.284 21.3969 18.3746C20.6062 20.3498 20.0458 22.4097 19.7267 24.5132C18.0774 25.8413 16.5847 27.3529 15.2773 29.0187C14.2002 27.4558 13.5596 25.634 13.4216 23.7409ZM15.2773 31.2443C16.5853 32.91 18.0784 34.4215 19.7279 35.7498C20.0474 37.8536 20.6082 39.9137 21.3994 41.8891C18.9723 41.9809 16.9437 41.544 15.5547 40.6277C15.9103 40.1822 16.1047 39.6295 16.1064 39.0595C16.1064 37.6507 14.9643 36.5087 13.5555 36.5087C13.5096 36.5087 13.4669 36.5202 13.4216 36.5221C13.5598 34.6291 14.2004 32.8073 15.2773 31.2443Z"
			fill="black"
		/>
	</svg>
);
export const CodeIcon = () => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width={60} height={60} rx={15} fill="white" />
		<path
			d="M36.0578 36.8783C35.8382 36.8771 35.6244 36.8078 35.4457 36.6801C35.2671 36.5523 35.1324 36.3724 35.0601 36.165C34.9879 35.9576 34.9817 35.7329 35.0423 35.5219C35.1029 35.3108 35.2275 35.1237 35.3988 34.9862L41.8617 29.9052L35.4838 24.8667C35.3742 24.7802 35.2828 24.6729 35.2147 24.551C35.1465 24.4291 35.1031 24.295 35.0868 24.1563C35.0705 24.0176 35.0817 23.8771 35.1197 23.7427C35.1578 23.6084 35.2219 23.4828 35.3084 23.3733C35.395 23.2637 35.5023 23.1722 35.6242 23.1041C35.746 23.036 35.8802 22.9925 36.0188 22.9763C36.1575 22.96 36.2981 22.9712 36.4324 23.0092C36.5668 23.0472 36.6923 23.1113 36.8019 23.1979L44.2427 29.0655C44.3707 29.1648 44.4744 29.2922 44.5456 29.4377C44.6169 29.5832 44.654 29.7432 44.654 29.9052C44.654 30.0673 44.6169 30.2272 44.5456 30.3727C44.4744 30.5183 44.3707 30.6456 44.2427 30.745L36.7062 36.6232C36.5249 36.7787 36.2965 36.8686 36.0578 36.8783Z"
			fill="black"
		/>
		<path
			d="M23.8548 38.4622C23.6199 38.4614 23.3919 38.3829 23.2064 38.2389L15.3829 32.1269C15.2601 32.0246 15.1619 31.8961 15.0957 31.7507C15.0294 31.6053 14.9968 31.4468 15.0002 31.2871C15.0022 31.1266 15.0406 30.9686 15.1124 30.825C15.1842 30.6814 15.2876 30.5559 15.4148 30.458L23.1745 24.3459C23.2848 24.2593 23.411 24.1954 23.546 24.1576C23.681 24.1199 23.8221 24.1091 23.9613 24.1258C24.1005 24.1426 24.235 24.1866 24.3572 24.2554C24.4793 24.3242 24.5867 24.4163 24.6733 24.5266C24.7598 24.6369 24.8238 24.7631 24.8616 24.8981C24.8993 25.0331 24.9101 25.1742 24.8933 25.3134C24.8766 25.4526 24.8325 25.5871 24.7638 25.7093C24.695 25.8314 24.6029 25.9388 24.4926 26.0254L17.7852 31.3403L24.5457 36.6551C24.717 36.7925 24.8416 36.9797 24.9022 37.1907C24.9629 37.4018 24.9566 37.6265 24.8844 37.8339C24.8122 38.0413 24.6774 38.2212 24.4988 38.349C24.3201 38.4767 24.1063 38.5459 23.8867 38.5472L23.8548 38.4622Z"
			fill="black"
		/>
		<path
			d="M26.7565 44.7869H26.5227C26.3856 44.7567 26.2558 44.6997 26.1409 44.6192C26.0259 44.5386 25.9281 44.436 25.8529 44.3174C25.7778 44.1989 25.727 44.0666 25.7033 43.9282C25.6795 43.7898 25.6835 43.6481 25.7148 43.5113L32.0076 15.8528C32.0355 15.7149 32.0904 15.5838 32.1692 15.4673C32.248 15.3508 32.3492 15.2511 32.4669 15.174C32.5846 15.0968 32.7164 15.0438 32.8547 15.018C32.993 14.9922 33.135 14.9941 33.2726 15.0236C33.4087 15.055 33.5373 15.1128 33.6511 15.1939C33.7649 15.275 33.8616 15.3777 33.9356 15.4962C34.0096 15.6146 34.0596 15.7465 34.0826 15.8843C34.1057 16.0221 34.1013 16.1631 34.0698 16.2992L27.7557 43.9578C27.7042 44.1869 27.5782 44.3926 27.3974 44.5426C27.2167 44.6926 26.9913 44.7785 26.7565 44.7869Z"
			fill="black"
		/>
	</svg>
);
